import { ProductManagementState } from 'types/productTypes';

export const ProductManagementInitialState: ProductManagementState = {
  processingStatus: {
    loading: false,
    error: '',
  },
  fetchProductOptions: {
    isLoadProductOptionsSuccess: false,
    GetProductOptions: [],
  },
};
